require('bootstrap');
require('angular');
require('angular-sanitize');
require('./PwnFMGate.service');
require('./PwnFMGateConstants');

module.exports = angular.module('PwnFMSubscriptionApp', ['ngSanitize', 'PwnFMGateServices', 'PwnFMGateConstants'])
.config( ['emailFromProcessorProvider', function(emailFromProcessorProvider) {
    emailFromProcessorProvider.setFmgateData({list:'exwwuprryf', keytype:'pwn', pochodzenie:'wstronenieba.pwn.pl', zrodlo:'pobranie ebooka', zgody_tryb:'auto'});
}])
.directive('pwnFmSubscriptionDialogs', function() {
    return {
        templateUrl: pwnFmsubscriptionApp.vendorBaseURL + '/fm_subscription/jstpl/fmSubscriptionDialogs.tpl.html',
        controller: [ '$scope', '$element', '$attrs', '$window', '$sce', 'emailFromProcessor', 'FMSubscriberStates', 'ModalAlerts', 'BranchesOfScience', function( $scope, $element, $attrs, $window, $sce, emailFromProcessor, FMSubscriberStates, ModalAlerts, BranchesOfScience ) {
            
            $scope.baseURL = pwnFmsubscriptionApp.vendorBaseURL;
            $scope.downloadPage = pwnFmsubscriptionApp.naDownloadPage;
            $scope.emailModalSpinner = false;
            $scope.unsubscribedModalSpinner = false;
            $scope.specializationModalSpinner = false;
            $scope.modalAlert = '';

            $scope.formSubmitted = false;
            
            $scope.zgodyPWN = {
                zgodaPS: zgodyPwn.zgoda_p_s,
                zgodaOS: zgodyPwn.zgoda_o_s,
                zgodaP: zgodyPwn.zgoda_p,
                zgodaO: zgodyPwn.zgoda_o,
                adminInfo:  $sce.trustAsHtml(zgodyPwn.admin_info)
            }

            $element.find('#zgoda_o_chck').find('[data-toggle="tooltip"]').tooltip({
                placement: 'bottom',
                title: $scope.zgodyPWN.zgodaO
            });
            $element.find('#zgoda_p_chck').find('[data-toggle="tooltip"]').tooltip({
                placement: 'bottom',
                title: $scope.zgodyPWN.zgodaP
            });
            $element.find('.modal').on('hide.bs.modal', function (e) {
                e.stopPropagation();
                jQuery('body').css('padding-right','');
            });
            
            $scope.branchesOfScience = BranchesOfScience;
            
            var edition = '';
            var jqEmailModal = $element.find('#fmSubscriptionEmailModal');
            var jqAlertModal = $element.find('#fmSubscriptionAlertModal');
            var jqUnsubscribedModal = $element.find('#fmUnsubscribedModal');
            var jqSpecializationModal = $element.find('#fmSpecializationModal');
            
            $scope.subscriber = {
                email: '',
                zgoda_p: false,
                zgoda_o: false
            }
            
            jqEmailModal.on('show.bs.modal', function(event) {
                var button = angular.element(event.relatedTarget);
                edition = button.data('edition') // Extract info from data-* attributes
            });
            
            jqEmailModal.on('hidden.bs.modal', function() {
                
            });

            $scope.downloadRedirect = function( edition ) {
                var downloadURL = $scope.downloadPage.concat('?email=', $scope.subscriber.email);
                if(edition) downloadURL = downloadURL.concat('&edition=', edition);
                $window.location.href = downloadURL;
            }
            
            $scope.submitEmailForm = function() {
                
                //if( !edition ) return;
                $scope.formSubmitted = true;
                if( $scope.fmSubscriptionEmailForm.$invalid ) return;
                
                $scope.emailModalSpinner = true;
                //console.log('submit %d', edition);
                //console.log($scope.subscriber);
                emailFromProcessor.launch($scope.subscriber.email).then(function(response) {
                    
                    if(response.action == 'branch_of_science_needed') {
                        $scope.emailModalSpinner = false;
                        jqEmailModal.modal('hide');
                        jqSpecializationModal.modal('show');
                    }
                    
                    if( response.action == "check_existing_subscriber" ) {
                        /*
                        response.action = "check_existing_subscriber"
                        response.fmSubscriberData = {...}
                        response.fmSubscriberData.state = ...
                        response.alert
                         */
                        var subscriber_state = parseInt(response.fmSubscriberData.state);
                        if( subscriber_state == FMSubscriberStates.SUBSCRIBER_STATUS_ACTIVE ) {
                            
                            if( !response.fmSubscriberData['dziedzina naukowa'] ) {
                                $scope.emailModalSpinner = false;
                                jqEmailModal.modal('hide');
                                jqSpecializationModal.modal('show');
                                
                            } else {
                                $scope.emailModalSpinner = false;
                                jqEmailModal.modal('hide');
                                //DOWNLOA ALLOWED
                                //ga('send', 'event', 'subskrypcja', 'pobranie', 'fm status: aktywny');
                                $scope.downloadRedirect( edition );
                            }
                            
                        } else if( subscriber_state == FMSubscriberStates.SUBSCRIBER_STATUS_UNSUBSCRIBED ) {
                            $scope.emailModalSpinner = false;
                            jqEmailModal.modal('hide');
                            $scope.modalAlert = ModalAlerts.UNSUBSCRIBED;
                            //ga('send', 'event', 'formularze', 'wypełnienie', 'fm status: wypisany');
                            jqUnsubscribedModal.modal('show');
                            
                        } else if( subscriber_state == FMSubscriberStates.SUBSCRIBER_STATUS_UNCONFIRMED ) {
                            
                            emailFromProcessor.resendActivationLink(edition)
                            .then( function(response) {
                                
                                $scope.emailModalSpinner = false;
                                jqEmailModal.modal('hide');
                                
                                if( response.status = 'OK' ) {
                                    
                                    $scope.modalAlert = ModalAlerts.UNCONFIRMED;
                                    //ga('send', 'event', 'formularze', 'wypełnienie', 'fm status: do aktywacji');
                                    jqAlertModal.modal('show');
                                    
                                } else {
                                    $scope.modalAlert = ModalAlerts.UNEXPECTED_ERROR;
                                    jqAlertModal.modal('show');
                                }
                                
                            }, function(response) {
                                $scope.emailModalSpinner = false;
                                jqEmailModal.modal('hide');
                                $scope.modalAlert = ModalAlerts.REQUEST_ERROR;
                                jqAlertModal.modal('show');
                            });
                            
                        } else if( subscriber_state == FMSubscriberStates.SUBSCRIBER_STATUS_UNACTIVE ) {
                            
                            emailFromProcessor.addUnactive(edition)
                            .then(function(response) {
                                
                                $scope.emailModalSpinner = false;
                                jqEmailModal.modal('hide');
                                
                                if( response.status = 'OK' ) {
                                    $scope.modalAlert = ModalAlerts.UNCONFIRMED;
                                    //ga('send', 'event', 'formularze', 'wypełnienie', 'fm status: nie aktywowany');
                                    jqAlertModal.modal('show');
                                } else {
                                    $scope.modalAlert = ModalAlerts.UNEXPECTED_ERROR;
                                    jqAlertModal.modal('show');
                                }
                                
                            }, function(response) {
                                $scope.emailModalSpinner = false;
                                jqEmailModal.modal('hide');
                                $scope.modalAlert = ModalAlerts.REQUEST_ERROR;
                                jqAlertModal.modal('show');
                            });
                    
                        } else {
                            // SUBSCRIBER BOUNCED
                            $scope.emailModalSpinner = false;
                            jqEmailModal.modal('hide');
                            $scope.modalAlert = ModalAlerts.BOUNCED;
                            //ga('send', 'event', 'formularze', 'wypełnienie', 'fm status: odbijający');
                            jqAlertModal.modal('show');
                        }
                        
                    }
                    
                }, function(response) {
                    jqEmailModal.modal('hide');
                    $scope.emailModalSpinner = false;
                    //Wyświetl dialog o błędzie
                    $scope.modalAlert = ModalAlerts.REQUEST_ERROR;
                    jqAlertModal.modal('show');
                });
                
            }
            
            $scope.submitSpecializationForm = function() {
                
                $scope.specializationModalSpinner = true;
                if( $scope.fmBranchOfScienceForm.$invalid ) return;
                var fmSubscriberData = emailFromProcessor.getFmSubscriberData();
                
                if( parseInt(fmSubscriberData.state) == FMSubscriberStates.SUBSCRIBER_STATUS_ACTIVE ) {
                    
                    emailFromProcessor.updateSubscriberCustom('dziedzina_naukowa', $scope.subscriber.branchOfScience, edition)
                    .then( function(update_response) {
                        $scope.specializationModalSpinner = false;
                        jqSpecializationModal.modal('hide');
                        
                        //DOWNLOAD ALLOWED
                        //ga('send', 'event', 'subskrypcja', 'pobranie', 'status: aktywny');
                        $scope.downloadRedirect( edition );
                        
                    }, function(update_response) {
                        $scope.specializationModalSpinner = false;
                        jqSpecializationModal.modal('hide');
                        $scope.modalAlert = ModalAlerts.REQUEST_ERROR;
                        jqAlertModal.modal('show');
                    });
                }
                
                /* SUBSKRYBENT NIE ISTNIEJE */
                if( angular.equals({}, fmSubscriberData ) ) {
                    emailFromProcessor.addFmSubscriber($scope.subscriber.email, $scope.subscriber.branchOfScience, edition).then(function( add_response ) {

                        if( add_response.data.status == "OK" ) {
                            $scope.specializationModalSpinner = false;
                            jqSpecializationModal.modal('hide');
                            $scope.modalAlert = ModalAlerts.ADDED;
                            jqAlertModal.modal('show');
                        }

                    }, function( add_response ) {

                        $scope.specializationModalSpinner = false;
                        jqSpecializationModal.modal('hide');
                        $scope.modalAlert = ModalAlerts.REQUEST_ERROR;
                        jqAlertModal.modal('show');

                    });
                }
                
            }
            
            $scope.submitUnsubscribedForm = function() {
                
                $scope.unsubscribedModalSpinner = true;
                emailFromProcessor.resubscribe( edition ).then(function( response ) {
                    
                    
                    jqUnsubscribedModal.modal('hide');
                    
                    if(response.data.status == 'OK') {
                        
                        //DOWNLOAD ALLOWED
                        //ga('send', 'event', 'subskrypcja', 'pobranie', 'status: aktywny, reaktywacja');
                        $scope.downloadRedirect( edition );
                        
                    } else {
                        $scope.unsubscribedModalSpinner = false;
                        $scope.modalAlert = ModalAlerts.UNEXPECTED_ERROR;
                        jqAlertModal.modal('show');
                    }
                    
                }, function( response ) {
                    
                    $scope.unsubscribedModalSpinner = false;
                    jqUnsubscribedModal.modal('hide');
                    $scope.modalAlert = ModalAlerts.REQUEST_ERROR;
                    jqAlertModal.modal('show');
                    
                });
            }
        }]
    }
});


//////////////////
// WEBPACK FOOTER
// ./vendor/fm_subscription/js/PwnFMSubscriptionApp.js
// module id = 10
// module chunks = 0